import * as React from 'react';
import { createContext, useContext, useMemo } from 'react';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import { CoachStateProvider } from 'bundles/unified-common/providers/CoachStateProvider';

export type AiAssistanceExperimentContextType = {
  aiAssistanceEnabled: boolean;
};

export const AiAssistanceExperimentContext = createContext<AiAssistanceExperimentContextType>({
  aiAssistanceEnabled: false,
});

function AiAssistanceExperimentProvider({ children }: React.PropsWithChildren) {
  const aiAssistanceOnLOHP = useMemo(() => GrowthDiscoveryEpicClient.get('aiAssistanceOnLOHP'), []);
  const aiAssistanceEnabled = aiAssistanceOnLOHP !== 'control';

  return (
    <AiAssistanceExperimentContext.Provider
      value={{
        aiAssistanceEnabled,
      }}
    >
      {aiAssistanceEnabled ? <CoachStateProvider>{children}</CoachStateProvider> : children}
    </AiAssistanceExperimentContext.Provider>
  );
}

export const useAiAssistanceExperimentData = () => {
  return useContext(AiAssistanceExperimentContext);
};

export default AiAssistanceExperimentProvider;
